export const routes = {
  home: '/subscriptions',
  login: '/preauth/login',
  accountSelect: '/preauth/account-select',
  customerSignup: '/preauth/customer-sign-up',
  merchantSignup: '/preauth/merchant-sign-up',
  forgotPassword: '/preauth/forgot',
  subscriptions: '/subscriptions',
  apis: '/api_manager/apis',
  billing: '/billing',
  accountSettings: '/account-settings',
  accountSettingsAccount: '/account-settings/account',
  createAccount: '/create/account',
  createAPI: '/api_manager/create/api',
  createCharge: '/create/charge',
  addCurrency: '/create/currency',
  onboardMerchant: '/onboard/merchant',
  merchantBilling: '/api_manager/billing',
  activity: '/activity',
  userProfile: '/user/profile',
  updateCharge: '/api_manager/update/charge',
  updateApi: '/api_manager/update/api',
  api: '/api_manager/api',
};
